module.exports = __webpack_public_path__ + "img/fish haiba.ddab9e8b.jpg";